import React from 'react';

import Question from '../elements/question';
import Feedback from '../elements/feedback';
import {SubsidieBox, WarningBox} from '../elements/infoboxes'

import { ConnectState } from '../zviz3/Connect';
import { checkConditions } from '../helpers/conditions';
import Icon from '../elements/icon';


const questions = [
    {
        name: 'f1',
        question: 'Heeft u voor- en achterdeuren vervangen door isolerende deuren?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [ 
            {variable: 'e', value: true, type: 'equal'}
        ]
    },
    {
        name: 'f2',
        question: 'Voldoen de nieuwe deuren aan de gestelde voorwaarden?',
        explanation: 'De nieuwe deur mag een U-waarde van maximaal 1,5 W/m\u00b2K hebben om in aanmerking te komen. De U-waarde (vroeger de K-waarde) drukt de hoeveelheid warmte uit die per m² tussen de ene en de andere zijde van een wand, ruit of andere constructie doorgelaten wordt. De U-waarde wordt ook wel warmtedoorgangscoëfficiënt genoemd. Controleer bij de fabrikant of uitvoerder of U-waarde van het gebruikte materiaal aan de eisen voldoet.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f1', value: true, type: 'equal'}
        ]
    },
    {
        name: 'f3',
        question: "Heeft u CO\u2082-gestuurde ventilatie aangelegd?",
        explanation: "Heeft u naast CO\u2082-gestuurde ventilatie ook balansventilatie met warmteterugwinning aangelegd, dan kunt u subsidie krijgen voor 1 van de 2 systemen. Wilt u subsidie aanvragen voor de balansventilatie, vult u dan bij deze vraag \"nee\" in.",
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f1', value: false, type: 'equal'},
            {variable: 'f2', value: null, type: 'not_equal'}
        ]
    },
    {
        name: 'f4',
        question: "Is er al eerder in de woning CO\u2082-gestuurde ventilatie aangelegd?",
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f3', value: true, type: 'equal'},
        ]
    },
    {
        name: 'f5',
        question: 'Heeft u een systeem voor balansventilatie met warmteterugwinning (wtw) aangelegd?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f3', value: false, type: 'equal'},
            {variable: 'f4', value: true, type: 'equal'}
        ]
    },
    {
        name: 'f6',
        question: 'Is er al eerder in de woning een systeem voor balansventilatie met warmteterugwinning (wtw) aangelegd?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f5', value: true, type: 'equal'}
        ]
    },
    {
        name: 'f7',
        question: 'Heeft het systeem een rendement van ten minste 90%?',
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f6', value: false, type: 'equal'}
        ]
    },
    {
        name: 'f8',
        question: 'Heeft u het verwarmingssysteem waterzijdig ingeregeld?',
        explanation: 'Het waterzijdig inregelen zorgt ervoor dat elke radiator het juiste volumestroom water krijgt. Dit gebeurt door de doorstoom per radiator goed in te regelen zodat het systeem een goed verdeelde doorstroming krijgt. Hiervoor moet een radiator ver van de cv-ketel moet een grotere opening hebben dan een radiator dichtbij de ketel. De optimale instelling hiervoor vinden is het waterzijdig inregelen van uw verwarmingssysteem. Dit maakt het verwarmingssysteem efficienter in gebruik en zo bespaart u energie.',
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f5', value: false, type: 'equal'},
            {variable: 'f6', value: true, type: 'equal'},
            {variable: 'f7', value: null, type: 'not_equal'},
            {variable: 'f4', value: false, type: 'equal'},
        ]
    },
    {
        name: 'f9',
        question: "Heeft u een energiedisplay of thermostaat geplaatst?",
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f8', value: null, type: 'not_equal'}
        ]
    },
    {
        name: 'f10',
        question: "Geeft het energiedisplay het actuele energieverbruik in de woning weer?",
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f9', value: true, type: 'equal'},
        ]
    },
    {
        name: 'f11',
        question: "Stemt de thermostaat het energieverbruik af op het leefgedrag van de bewoners?",
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f10', value: true, type: 'equal'},
        ]
    },
    {
        name: 'f12',
        question: "Kan de thermostaat de temperatuur van afzonderlijke ruimten in de woning regelen?",
        explanation: null,
        options: [
            {value: true, label: 'Ja'},
            {value: false, label: 'Nee'}
        ],
        conditions: [
            {variable: 'f11', value: false, type: 'equal'},
        ]
    }
]

const condDeur = [
    {variable: 'f2', value: true, type: 'equal'}
];
const condCO2 = [
    {variable: 'f4', value: false, type: 'equal'},
];
const condVentilatie = [
    {variable: 'f7', value: true, type: 'equal'},
];
const condWaterzijdig = [
    {variable: 'f8', value: true, type: 'equal'},
];
const condThermostaat = [
    {variable: 'f11', value: true, type: 'equal'},
    {variable: 'f12', value: true, type: 'equal'},
];

const concludedQuestions = [
    {variable: 'f9', value: false, type: 'equal'},
    {variable: 'f10', value: false, type: 'equal'},
    {variable: 'f11', value: true, type: 'equal'},
    {variable: 'f12', value: null, type: 'not_equal'}   
];

export const getSubsidies = function(){
    let text = [];
    if(checkConditions(condDeur)){
        text.push("Isoleren van deuren € 80 per m\u00b2");
    }
    if(checkConditions(condCO2)){
        text.push("CO\u2082-gestuurde ventilatie: tot 20% van de kosten (inclusief btw) van het ventilatiesysteem met een maximum van € 800");
    }
    if(checkConditions(condVentilatie)){
        text.push("Balansventilatie: tot 20% van de kosten (inclusief btw) van het ventilatiesysteem met een maximum van € 800");
    }
    if(checkConditions(condWaterzijdig)){
        text.push("Voor het waterzijdig inregelen van het verwarmingssyteem € 60");
    }
    if(checkConditions(condThermostaat)){
        text.push("Voor een energiedisplay of een thermostaat € 100");
    }
    return text;
}

const feedback = [
    {
        content: () => ( <SubsidieBox text={getSubsidies()} /> ),
        name: 'f',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                // conditions to match to get the subsidy
                {type: 'group', conditions: [...condDeur, ...condCO2, ...condVentilatie, ...condWaterzijdig, ...condThermostaat]},

                // set of conditions to identify that the question has concluded
                {type: 'group', conditions: concludedQuestions},
            ]}
        ]    
    },

    {
        content: <WarningBox text="U komt niet in aanmerking voor subsidie voor aanvullende maatregelen" />,
        name: 'f',
        value: true,
        conditions: [
            {type: 'and', conditions: [
                // condition the question has concluded
                {type: 'group', conditions: concludedQuestions},

                // condition, we do not have a success anywhere
                {type: 'nor', conditions: [...condDeur, ...condCO2, ...condVentilatie, ...condWaterzijdig, ...condThermostaat]}
            ]},
        ]    
    },
];

const sectionConditions = [
    {type: 'and', conditions: [
        {variable: 'b', value: true, type: 'equal'},
        {variable: 'c', value: true, type: 'equal'},
        {variable: 'd', value: true, type: 'equal'},
        {variable: 'e', value: true, type: 'equal'}
    ]}
];

function SectionF(props){

    if(checkConditions(sectionConditions)){
        return <div className="seehi_section">
            <h2 className="seehi_iconHeader"><Icon type="extra" />Aanvullende energiebesparende maatregelen</h2>
            <p>Binnen deze subsidieregeling vallen ook nog een aantal andere optionele energiebesparende maatregelen zoals energiezuinige ventilatiesystemen of een slimme thermostaat. Deze maatregelen zijn niet vereist om in aanmerking te komen voor de overige subsidies.</p>

            {questions.map((props, i) => ( <Question key={i} {...props} /> ))}
        
            {feedback.map((props, i) => ( <Feedback key={i} {...props} /> ))}
            
        </div>;
    }

    return '';
}

export default ConnectState(SectionF, 'answers');



// WEBPACK FOOTER //
// ./src/sections/f.js